/**
 * Fixed delay when randomization is disabled
 */
export const DEFAULT_FIXED_DELAY = 2500; // ms

/**
 * Update interval for delay progress (affects timeline progress smoothness)
 * Lower = smoother but more store updates
 */
export const DELAY_UPDATE_INTERVAL = 50; // ms



